import { useMemo } from 'react';
import { SelectedMarketsDisplay } from '../../../../SelectedMarketsDisplay/SelectedMarketsDisplay';

const MAX_VISIBLE_MARKETS = 3;

type MarketEntry = { Market?: string };

interface MarketsValueProps {
  markets?: MarketEntry[];
}

export function MarketsValue({ markets }: MarketsValueProps) {
  const selectedMarkets = useMemo(
    () =>
      (markets ?? [])
        .map(entry => entry.Market?.trim())
        .filter((market): market is string => typeof market === 'string' && market.length > 0),
    [markets]
  );

  return (
    <SelectedMarketsDisplay
      aggregation={undefined}
      markets={selectedMarkets}
      marketAccounts={undefined}
      placeholder="-"
      maxVisibleItems={MAX_VISIBLE_MARKETS}
      overflowTrigger="badge"
      justifyContent="flex-end"
      flex="0 1 auto"
    />
  );
}
